export { defaultUnpatchedConsole } from './const';

export { initializeUnpatchedConsole, unpatchedConsole } from './initialize';

export type { UnpatchedConsole } from './types';



// WEBPACK FOOTER //
// ../../../src/unpatchedConsole/index.ts